
import Loading from 'vux/src/components/loading/index.vue'

import DevicePanel from "./devicePanel.vue";
import {getDevList} from "../../../api/index";
import {aligenie} from "../../../utils/tmallGenius";
export default {
components: {Loading, DevicePanel},
data() {
return {
isNoDevice: undefined, //无设备
isLoading: false,
deviceList: []
};
},
/*------------------------------------------- 开始运行 -------------------------------------------------------*/
created() {

let token =
this.$route.query.access_token ||
sessionStorage.getItem("token") ||



'7abc85504149460bb9c364b132542e2a';  //我的账号:13790371603 123456
sessionStorage.setItem("token", token); //存起来后面接口用

aligenie.getRoomList().then(() => {
this.getData(token);
});
},
methods: {
/*------------------------------------------- 绑定函数 -------------------------------------------------------*/
/*------------------------------------------- 自定义函数 -------------------------------------------------------*/
/*  获取设备列表
* @param token登录获取的token
* */
getData(token) {
if (!token) {
this.isNoDevice = true; //无设备
} else {
this.isLoading = true;
getDevList({
token: token
})
.then(res => {
this.isLoading = false;
if (res.status === 0) {

this.deviceList = res.data || [];
this.isNoDevice = this.deviceList.length === 0; //有无设备
setTimeout(() => {

window.scrollTo(0, sessionStorage.getItem("scrollY") || 0);
}, 0);
}
})
.catch(() => {
this.isLoading = false;
});
}
}
}
};



// WEBPACK FOOTER //
// ./src/pages/Home/deviceLIst/Index.vue